import { useSWRConfig } from "swr"
import useResource from "./useResource"

import { pluralize } from "web/services/inflector"

export default function useViewGroup({
  parentSubjectType,
  parentSubjectId,
  subjectType,
  topicId,
}) {
  const { cache, mutate } = useSWRConfig()
  const parentRoute = `${pluralize(parentSubjectType)}/${parentSubjectId}`

  const key =
    topicId !== undefined
      ? `${parentRoute}/${topicId}/view_group`
      : `${parentRoute}/view_group/${subjectType.toLowerCase()}`

  const [viewGroup] = useResource({ key })

  // cache result to avoid fetching again right away in ObjectList > useView
  const viewKey = `view_groups/${viewGroup.id}`
  if (!cache.has(viewKey)) {
    mutate(viewKey, viewGroup, false)
  }

  return viewGroup
}
